<template>
  <div class="component-wrapper secondary d-flex flex-column">
    <div class="d-flex px-2">
      <v-btn icon @click="$router.push('/pois')">
        <v-icon color="white" size="17">mdi-arrow-left</v-icon>
      </v-btn>
    </div>

    <div
      class="d-flex align-center px-4 mb-4"
      @click="showFilters = !showFilters"
    >
      <v-icon color="white" class="mr-2">mdi-tune-vertical</v-icon>
      <span class="body-1 white--text">
        {{ $t("general.filters_label") }}
      </span>
    </div>

    <div v-if="showFilters" class="d-flex flex-column pa-2 mb-4 align-center">
      <v-select
        @change="filterApply"
        :items="categories"
        :label="$t('general.categories_label')"
        item-text="name"
        item-value="id"
        v-model="filters.category"
        color="white"
        dark
        hide-details
        style="width: 350px"
        class="mb-2"
      >
      </v-select>

      <v-select
        @change="filterApply"
        v-model="filters.island"
        :items="islands"
        :label="$t('general.islands_label')"
        item-text="name"
        item-value="id"
        color="white"
        dark
        hide-details
        style="width: 350px"
      >
      </v-select>
    </div>

    <div
      v-if="loader"
      class="d-flex flex-column align-center flex-grow-1"
      style="height: 500px"
    >
      <v-progress-circular indeterminate color="white" size="60">
      </v-progress-circular>
    </div>

    <div
      v-else-if="!loader && pois.length > 0"
      v-for="(route, i) in pois"
      :key="i"
      class="d-flex flex-column px-4"
      style="width: 100%"
    >
      <div
        @click="$router.push(`${$route.path}/${route.id}`)"
        class="d-flex justify-start align-center white--text route font-weight-thin body-1 mb-2"
      >
        <span class="mr-auto">{{ route.name }}</span>
        <v-btn icon color="white">
          <v-icon> mdi-arrow-right</v-icon>
        </v-btn>
      </div>

      <v-divider
        v-if="i != pois.length - 1"
        class="mb-2"
        style="width: 100% !important"
        color="white"
      ></v-divider>
    </div>
  </div>
</template>
  
  <script>
import axios from "axios";
import { mapMutations } from "vuex";
export default {
  async created() {
    try {
      const categories = await axios.get(
        `${process.env.VUE_APP_BASE_URL}/categories`
      );

      const areas = await axios.get(`${process.env.VUE_APP_BASE_URL}/areas`);

      const pois = await axios.get(`${process.env.VUE_APP_BASE_URL}/pois`, {
        params: {
          area: this.filters.island,
          category: this.filters.category != 17 ? this.filters.category : null,
        },
      });

      const sortedAreas = areas.data.areas.sort((a, b) => {
        return a.weight - b.weight;
      });

      this.categories = categories.data;

      this.pois = pois.data;

      this.islands = sortedAreas;

      this.loader = false;
      //todo -> add category query param
    } catch (e) {
      this.loader = false;
      console.log(e);
    }
  },

  data() {
    return {
      showFilters: false,
      loader: true,
      pois: [],
      islands: [],

      categories: [],
    };
  },

  computed: {
    filters: {
      get() {
        return this.$store.state.base.filters;
      },
      set(newValue) {
        this.setFilters(newValue);
      },
    },
  },

  methods: {
    ...mapMutations(["setFilters"]),

    async filterApply() {
      try {
        this.loader = true;

        this.pois = [];
        const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/pois`, {
          params: {
            area: this.filters.island,
            category:
              this.filters.category != 17 ? this.filters.category : null,
          },
        });
        this.pois = res.data;
        this.loader = false;
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
  
  <style scoped lang="scss">
</style>